import React, { useEffect, useState } from 'react';
import { Box, Button } from '@mui/material';

export interface StatusToggleProps {
  options: string[];
  value: string;
  onChange: (newValue: string) => void;
}

export const StatusToggle: React.FC<StatusToggleProps> = ({
  options,
  value,
  onChange,
}) => {
  const [selected, setSelected] = useState(value);

  useEffect(() => {
    setSelected(value);
  }, [value]);

  const handleToggle = (option: string) => {
    setSelected(option);
    onChange(option);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        borderRadius: '9999px',
        p: '2px',
        width: 'auto',
        bgcolor: 'action.hover',
        overflow: 'hidden',
        maxWidth: 260,
      }}
    >
      {options.map((option) => {
        const isSelected = selected === option;
        return (
          <Button
            key={option}
            size='small'
            onClick={() => handleToggle(option)}
            sx={{
              px: 1.5,
              py: 0.5,
              fontSize: '0.75rem',
              fontWeight: 500,
              borderRadius: '9999px',
              flex: 1,
              minWidth: 0,
              textTransform: 'none',
              bgcolor: isSelected ? 'background.paper' : 'transparent',
              color: isSelected ? 'primary.main' : 'text.secondary',
              boxShadow: isSelected ? 1 : 'none',
              '&:hover': {
                bgcolor: isSelected ? 'background.paper' : 'action.selected',
                color: 'primary.dark',
              },
            }}
          >
            {option}
          </Button>
        );
      })}
    </Box>
  );
};

export default StatusToggle;
